import React from 'react';
import { Link } from 'react-router-dom';
import { bunnyLogoSrc } from '../constants/branding';
import { useScrollY } from '../hooks';
import styles from '../styles/Nav.module.css';

export type NavVariant = 'full' | 'logoOnly';

interface NavProps {
  variant?: NavVariant;
}

const Nav: React.FC<NavProps> = ({ variant = 'full' }) => {
  const scrollY = useScrollY();
  const scrolled = scrollY > 20;

  const logo = (
    <Link to="/#home" className={styles.logoLink} aria-label="Home">
      <img src={bunnyLogoSrc} alt="" className={styles.logoMark} />
    </Link>
  );

  if (variant === 'logoOnly') {
    return (
      <nav
        className={`${styles.nav} ${styles.navLogoOnly} ${scrolled ? styles.scrolled : ''}`}
      >
        {logo}
      </nav>
    );
  }

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      {logo}

      <div className={styles.right}>
        {(['home', 'work', 'fun-work'] as const).map((label, i) => (
          <Link
            key={label}
            to={`/#${label}`}
            className={`${styles.navLink} ${i === 0 ? styles.active : ''}`}
          >
            {label}
          </Link>
        ))}
        <Link to="/#contact" className={styles.cta}>
          contact
        </Link>
      </div>
    </nav>
  );
};

export default Nav;
